/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface ItaapScope extends ng.IScope {
        vm: Taap;
    }

    interface Itaap {
        taapProspectView: TaapProspectView;
        first: string
    }

    export class TaapProspectView {
        source: string;
        name: IPersonName;
        email: string;
        mailingAddress: ProspectAddress;
        additionalData: any;
    }

    class PersonName implements IPersonName {
        first: string;
        middle: string;
        last: string;
        suffix: string;
        nickName: string;
    }

    class ProspectAddress {
        street1: string;
        street2: string;
        city: string;
        state: string;
        country: string;
        county: string;
        zip: string;
    }

    class AdditionalData {
        appliedToUncInstitution: boolean;
        deniedAdmission: boolean;
        denialsReceivedFrom: Array<any>;
        acceptedToUncInstitution: boolean;
        acceptedFrom: Array<any>;
        eligible: boolean;
        entryTerm: string;
        entryYear: number;
        intendedMajor: string;
        attendedComunityCollege: any;
        ccDegree: string;
        gradDate: Date;
        graduationYear: number;
        unweightedGPA: number;
    }

    class UncCollege {
        name: string;
        applicationDefinitionId: string;
    }

    class Taap implements Itaap {
        static controllerId: string = "taap";
        first: string;
        static $inject: string[] = ["$location", "common", "Restangular", "communityCollegeService"];
        show: string;
        taapProspectView: TaapProspectView;
        currentYear: number;
        disableForm: boolean;
        showSpinner: boolean;
        errorReason: string;
        multiSelectSettings: any;
        defaultDdlText: any;
        denialsReceivedFrom: any;
        acceptedFrom: Array<any>;
        uncColleges: Array<any>;
        communityColleges: Array<any>;
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;

        constructor(private $location: ng.ILocationService, private common: ICommonFactory, private Restangular: Restangular.IService, private communityCollegeService: ICommunityCollegeService) {
            this.log = common.logger.getLogFn(Taap.controllerId);
            this.logError = common.logger.getLogFn(Taap.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(Taap.controllerId, "success");

            this.taapProspectView = new TaapProspectView();
            this.taapProspectView.mailingAddress = new ProspectAddress();
            this.taapProspectView.name = new PersonName();
            this.taapProspectView.additionalData = new AdditionalData();
            this.taapProspectView.additionalData.denialsReceivedFrom = [];
            this.taapProspectView.additionalData.acceptedFrom = [];
            this.denialsReceivedFrom = [];
            this.acceptedFrom = [];
            this.communityColleges = communityCollegeService.getCommunityColleges();

            var month: number = new Date().getMonth();

            this.currentYear = new Date().getFullYear();
            if (month >= 9)
                this.currentYear++;
            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    this.activate();
                }
            });



        }

        activate() {
            var promises = [this.getUncSchools(), this.getUserProfile(), this.userHasProspect()];
            this.common.activateController(promises, Taap.controllerId)
                .then(() => {
                    if (!this.show) {
                        this.show = "Name";

                    }
                    this.logSuccess("Activated TAAP");
                });
            this.multiSelectSettings = {
                smartButtonMaxItems: 2,
                displayProp: "name",
                idProp: "applicationDefinitionId",
                showCheckAll: false
            };
            this.defaultDdlText = {
                buttonDefaultText: "Select one or more options"
            };

        }

        getUncSchools(): ng.IPromise<any> {
            return this.Restangular.all("institutions/getUncSchools").getList().then((result) => {
                this.uncColleges = result;

            }, (reason) => {
                this.errorReason = reason;
                this.show = "Error";
                this.logError(reason, reason);
            });
        }

        userHasProspect(): ng.IPromise<any> {
            return this.Restangular.one("Prospect/isProspectSubmitted").get().then((result) => {
                if (result) {
                    this.disableForm = true;
                    this.show = "Submitted"
                }
            }, (reason) => {
                this.errorReason = reason;
                this.show = "Error";
                this.logError(reason, reason);

            });
        }

        getUserProfile(): ng.IPromise<any> {
            //var deferred = this.common.$q.defer();

            return this.Restangular.one("users/profile").get()
                .then((result) => {
                    if (result) {
                        this.taapProspectView.name.first = result.firstName;
                        this.taapProspectView.name.middle = result.middleName;
                        this.taapProspectView.name.last = result.lastName;
                        this.taapProspectView.name.suffix = result.suffix;
                        this.taapProspectView.email = result.email;
                        result.mailAddress = result.mailAddress || new ProspectAddress();
                        this.taapProspectView.mailingAddress.street1 = result.mailAddress.street;
                        this.taapProspectView.mailingAddress.street2 = result.mailAddress.street2;
                        this.taapProspectView.mailingAddress.city = result.mailAddress.city;
                        this.taapProspectView.mailingAddress.state = result.mailAddress.state;
                        this.taapProspectView.mailingAddress.zip = result.mailAddress.postalCode;
                        this.taapProspectView.mailingAddress.county = result.mailAddress.county;
                        this.taapProspectView.mailingAddress.country = result.mailAddress.country;
                        //Profile carry over.
                        this.taapProspectView.name.nickName = result.nickname;
                        this.taapProspectView.additionalData.dayTime = result.daytimePhone;
                        this.taapProspectView.additionalData.evening = result.eveningPhone;
                    }
                }, (reason) => {
                    this.logError("An error occurred while retrieving your profile.", reason, true);
                });

        }


        submit() {
            this.showSpinner = true;
            this.taapProspectView.additionalData.denialsReceivedFrom = _.map(this.denialsReceivedFrom, "name");
            this.taapProspectView.additionalData.acceptedFrom = _.map(this.acceptedFrom, "name");
            var denials = _.map(this.denialsReceivedFrom, "applicationDefinitionId");
            var accept = _.map(this.acceptedFrom, "applicationDefinitionId");
            var allIds = _.union(denials, accept);

            this.taapProspectView.additionalData.excludedIds = allIds;


            if (this.taapProspectView.additionalData.deniedAdmission && !this.taapProspectView.additionalData.acceptedToUncInstitution) {
                this.taapProspectView.additionalData.eligible = true;
            }
            else {
                this.taapProspectView.additionalData.eligible = false;
            }


            this.Restangular.all("Prospect/insertprospecttaap").post({ prospect: this.taapProspectView, excludedAppIds: allIds })
                .then((result) => {
                    this.showSpinner = false;
                    if (this.acceptedFrom.length > 0) {
                        this.show = "Ineligible";
                    }
                    else if (this.denialsReceivedFrom.length < 1) {
                        this.show = "NotDenied";
                    }
                    else {
                        this.show = "ThankYou";
                    }
                    this.disableForm = true;
                    this.showSpinner = false;
                }, (reason) => {
                    this.showSpinner = false;
                    this.errorReason = reason;
                    this.show = "Error"
                    this.disableForm = true;
                    this.showSpinner = false;
                    this.logError(reason, reason, true);
                });
        }

    }

    angular.module("app").controller(Taap.controllerId, Taap);
}